import type { FaireProductEntity } from "../../entity_types/product";

export const p_p9ea5y74ne: FaireProductEntity = {
  token: "p_p9ea5y74ne",
  type: "product",
  name: "Hand Painted Metal Tibetan Singing Bowl Set",
  brandToken: "b_zz3uf54cby",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/48a9377f33cb6c54aa3b29636285c520e3b8b1599f210745883dd6ff8589cc58.jpeg",
  galleryImageUrls: [],
  priceDollars: 28.34,
  description:
    "\nStore Indya is a travel quest to unravel the forgotten hand crafted skills of India Store Indya was something that was created as a result of family trips we took across India While travelling, we not only saw different cultures in different parts of India, but we also realized each corner of India has its own secret They all have their own unique art forms thats known to only a very few in India, and almost unknown to the rest of the world We discovered that these age-old glorious skills are getting suppressed The artisans that we work with are trying to continue the dying legacy of their artwork Each artwork handcrafted by them is an end product of their hard and meticulous work Store Indya wants to revive these art forms and at the same time empower these skilled artists We want to present different art forms and create a whole new product by itself that has never been created before Overall, these products not only stand for aesthetics and traditions, but the designs on it also...",
  tags: [],
  msrpDollars: 56.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:13.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
